import React, { Fragment } from 'react';
import { useTranslation } from '@pascal/pascal-core';
import { GAME_RULES_HELP_KEYS } from '../../enums/constants';
import helpImg1 from '../../assets/images/helps/img_1.png';
import helpImg2 from '../../assets/images/helps/img_2.png';
import helpImg3 from '../../assets/images/helps/img_3.png';

const sortedImages = {
  8: helpImg1,
  10: helpImg2,
  12: helpImg3,
};

export function HelpPopup() {
  const t = useTranslation();

  return (
    <div className='help-popup-wrp'>
      {GAME_RULES_HELP_KEYS.map((item) => (
        <Fragment key={item}>
          <p className='game-rules-text'>{t(`GAME_RULES_P${item + 1}`)}</p>
          {!!sortedImages?.[item] && (
            <div className='help-popup-fb-field'>
              <img src={sortedImages?.[item]} alt='help-field' />
            </div>
          )}
        </Fragment>
      ))}

      <div className='non-stop-rules-table'>
        <div className='non-stop-rules-tb-row'>
          <div className='non-stop-rules-tb-row-item'>
            <p className='non-stop-rules-tb-row-item-text'>{t('GAME_RULES_P22')}</p>
          </div>
          <div className='non-stop-rules-tb-row-item'>
            <p className='non-stop-rules-tb-row-item-text gold'>{t('GAME_RULES_P26')}</p>
          </div>
        </div>
        <div className='non-stop-rules-tb-row'>
          <div className='non-stop-rules-tb-row-item'>
            <p className='non-stop-rules-tb-row-item-text'>{t('GAME_RULES_P23')}</p>
          </div>
          <div className='non-stop-rules-tb-row-item'>
            <p className='non-stop-rules-tb-row-item-text'>
              x<span>2</span>
            </p>
          </div>
        </div>
        <div className='non-stop-rules-tb-row'>
          <div className='non-stop-rules-tb-row-item'>
            <p className='non-stop-rules-tb-row-item-text'>{t('GAME_RULES_P24')}</p>
          </div>
          <div className='non-stop-rules-tb-row-item'>
            <p className='non-stop-rules-tb-row-item-text'>
              x<span>2</span>
            </p>
          </div>
        </div>
        <div className='non-stop-rules-tb-row'>
          <div className='non-stop-rules-tb-row-item'>
            <p className='non-stop-rules-tb-row-item-text'>{t('GAME_RULES_P25')}</p>
          </div>
          <div className='non-stop-rules-tb-row-item'>
            <p className='non-stop-rules-tb-row-item-text'>
              x<span>12</span>
            </p>
          </div>
        </div>
      </div>

      <p className='game-rules-text'>{t(`RTP`)}</p>

      <div className='non-stop-rules-table'>
        <div className='non-stop-rules-tb-row'>
          <div className='non-stop-rules-tb-row-item'>
            <p className='non-stop-rules-tb-row-item-text'>{t('Market')}</p>
          </div>
          <div className='non-stop-rules-tb-row-item'>
            <p className='non-stop-rules-tb-row-item-text gold'>{t('RTP')}</p>
          </div>
        </div>
        <div className='non-stop-rules-tb-row'>
          <div className='non-stop-rules-tb-row-item'>
            <p className='non-stop-rules-tb-row-item-text'>{t('GAME_RULES_P23')}</p>
          </div>
          <div className='non-stop-rules-tb-row-item'>
            <p className='non-stop-rules-tb-row-item-text'>96.27%</p>
          </div>
        </div>
        <div className='non-stop-rules-tb-row'>
          <div className='non-stop-rules-tb-row-item'>
            <p className='non-stop-rules-tb-row-item-text'>{t('GAME_RULES_P24')}</p>
          </div>
          <div className='non-stop-rules-tb-row-item'>
            <p className='non-stop-rules-tb-row-item-text'>96.27%</p>
          </div>
        </div>
        <div className='non-stop-rules-tb-row'>
          <div className='non-stop-rules-tb-row-item'>
            <p className='non-stop-rules-tb-row-item-text'>{t('GAME_RULES_P25')}</p>
          </div>
          <div className='non-stop-rules-tb-row-item'>
            <p className='non-stop-rules-tb-row-item-text'>89.64%</p>
          </div>
        </div>
      </div>
    </div>
  );
}
